import { EasingFunction, motion } from 'framer-motion';
import { useMemo } from 'react';

import { useTestEnvironmentTiming } from '../../../cypress/hooks/useTestEnvironmentTiming';

export const ScaleBox = ({
  children,
  delayOrder,
  duration = 0.4,
  easing = [0.42, 0, 0.58, 1],
}: {
  children: JSX.Element;
  delayOrder: number;
  duration?: number;
  easing?:
    | [number, number, number, number]
    | 'linear'
    | 'easeIn'
    | 'easeOut'
    | 'easeInOut'
    | 'circIn'
    | 'circOut'
    | 'circInOut'
    | 'backIn'
    | 'backOut'
    | 'backInOut'
    | 'anticipate'
    | EasingFunction;
}): JSX.Element => {
  const {
    duration: timingDuration,
    delay,
    animationState,
  } = useTestEnvironmentTiming({
    duration,
    delay: delayOrder / 5,
    initialState: 'hidden',
  });

  const transition = useMemo(
    () => ({
      duration: timingDuration,
      delay,
      ease: easing,
    }),
    [timingDuration, delay, easing],
  );

  const variants = {
    hidden: {
      scale: 0,
      opacity: 0,
      transition,
    },
    show: {
      scale: 1,
      opacity: 1,
      transition,
    },
  };

  return (
    <motion.div
      initial={animationState}
      animate="show"
      exit={animationState}
      variants={variants}
    >
      {children}
    </motion.div>
  );
};
